import { CheckCircle2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useGame } from '../game/GameContext';

export function NoticeToast() {
  const { state } = useGame();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!state.notice) return;
    setVisible(true);
    const timeout = window.setTimeout(() => setVisible(false), 3600);
    return () => window.clearTimeout(timeout);
  }, [state.notice]);
  if (!state.notice) return null;
  return (
    <div className={`notice-toast ${visible ? 'is-visible' : ''}`}>
      <CheckCircle2 /><span>{state.notice}</span>
    </div>
  );
}
